/* ==========================================================================
   CSA Main Product JavaScript
   Gallery Syncing (Main Swiper + 4-Thumbnail Swiper + Outer Arrows)
   Full Shopify Theme Editor Realtime Sync & Lifecycle Management
   ========================================================================== */

/* Global Smooth Scroll to Kaching / Purchase Section */
window.csaScrollToKachingPurchase = function (event) {
  if (event && event.preventDefault) event.preventDefault();

  const target = document.querySelector(
    '.kaching-bundles, .kaching-bundles__bar-wrapper, [data-kaching-bundles], product-form, .csa-block-buy-button, .product-form__submit, .csa-product-info, [id^="CSAMainProduct-"]'
  );

  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  return false;
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initCSAMainProductSections();
  });
} else {
  initCSAMainProductSections();
}

window.addEventListener('load', function () {
  initCSAMainProductSections();
});

/* Realtime Shopify Theme Editor Lifecycle Listeners */
document.addEventListener('shopify:section:load', function (event) {
  if (event.target.classList.contains('section-csa-main-product') || event.target.querySelector('.csa-swiper-main')) {
    initCSAMainProductSection(event.target);
  }
});

document.addEventListener('shopify:section:unload', function (event) {
  if (event.target.classList.contains('section-csa-main-product') || event.target.querySelector('.csa-swiper-main')) {
    destroyCSAMainProductSection(event.target);
  }
});

document.addEventListener('shopify:block:select', function (event) {
  const blockEl = event.target;
  const sectionEl = blockEl.closest('.csa-product-section');
  if (sectionEl) {
    const mainSwiperEl = sectionEl.querySelector('.csa-swiper-main');
    if (mainSwiperEl && mainSwiperEl.swiperInstance) {
      mainSwiperEl.swiperInstance.update();
    }
  }
});

function destroyCSAMainProductSection(section) {
  const mainSwiperEl = section.querySelector('.csa-swiper-main');
  const thumbsSwiperEl = section.querySelector('.csa-swiper-thumbs');

  if (thumbsSwiperEl && thumbsSwiperEl.swiperInstance) {
    thumbsSwiperEl.swiperInstance.destroy(true, true);
    thumbsSwiperEl.swiperInstance = null;
  }
  if (mainSwiperEl && mainSwiperEl.swiperInstance) {
    mainSwiperEl.swiperInstance.destroy(true, true);
    mainSwiperEl.swiperInstance = null;
  }
}

function initCSAMainProductSections() {
  const sections = document.querySelectorAll('.csa-product-section');
  sections.forEach(function (section) {
    initCSAMainProductSection(section);
  });
}

function initCSAMainProductSection(section) {
  const mainSwiperEl = section.querySelector('.csa-swiper-main');
  const thumbsSwiperEl = section.querySelector('.csa-swiper-thumbs');

  if (!mainSwiperEl) return;

  // Clean up any existing instances
  destroyCSAMainProductSection(section);

  if (typeof Swiper === 'undefined') {
    // Retry polling if Swiper script from CDN is still loading
    if (!section._swiperRetryCount) section._swiperRetryCount = 0;
    if (section._swiperRetryCount < 30) {
      section._swiperRetryCount++;
      setTimeout(function () {
        initCSAMainProductSection(section);
      }, 75);
    } else {
      initFallbackThumbClicks(section);
    }
    return;
  }

  // 1. Initialize Thumbnail Swiper
  let thumbsSwiper = null;
  if (thumbsSwiperEl) {
    const prevBtn = section.querySelector('.csa-thumb-prev');
    const nextBtn = section.querySelector('.csa-thumb-next');

    const mobileSlides = thumbsSwiperEl.dataset.mobileSlidesPerView
      ? parseFloat(thumbsSwiperEl.dataset.mobileSlidesPerView)
      : 5;
    const mobileSpace = thumbsSwiperEl.dataset.mobileSpaceBetween
      ? parseFloat(thumbsSwiperEl.dataset.mobileSpaceBetween)
      : 4;

    thumbsSwiper = new Swiper(thumbsSwiperEl, {
      slidesPerView: mobileSlides,
      spaceBetween: mobileSpace,
      freeMode: false,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      resizeObserver: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        750: {
          slidesPerView: 5,
          spaceBetween: 8,
          freeMode: false,
        },
      },
    });

    thumbsSwiperEl.swiperInstance = thumbsSwiper;
  }

  // 2. Initialize Main Gallery Swiper
  const mainSwiper = new Swiper(mainSwiperEl, {
    slidesPerView: 1,
    spaceBetween: 0,
    grabCursor: true,
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    resizeObserver: true,
    thumbs: {
      swiper: thumbsSwiper,
    },
  });

  mainSwiperEl.swiperInstance = mainSwiper;

  // Mobile counter controls
  const mobilePrev = section.querySelector('.csa-counter-prev');
  const mobileNext = section.querySelector('.csa-counter-next');
  const currentBadge = section.querySelector('.csa-counter-current');

  if (mobilePrev) {
    mobilePrev.addEventListener('click', function () {
      mainSwiper.slidePrev();
    });
  }
  if (mobileNext) {
    mobileNext.addEventListener('click', function () {
      mainSwiper.slideNext();
    });
  }

  mainSwiper.on('slideChange', function () {
    if (currentBadge) {
      currentBadge.textContent = mainSwiper.realIndex + 1;
    }
  });

  // Handle Tab Buttons inside Product Tabs block
  initTabs(section);

  // Handle Accordion / FAQ Dropdown toggles
  initAccordions(section);

  // Handle Dynamic Shipping Date
  initDynamicShippingDate(section);

  // Handle Variant Change Listener
  initVariantChangeListener(section, mainSwiper);

  // Trigger delayed update for smooth image height calculations
  setTimeout(function () {
    if (mainSwiper && !mainSwiper.destroyed) mainSwiper.update();
    if (thumbsSwiper && !thumbsSwiper.destroyed) thumbsSwiper.update();
  }, 120);
}

/* Fallback Thumbnail Click Handler when Swiper JS is delayed / blocked */
function initFallbackThumbClicks(section) {
  const mainSlides = section.querySelectorAll('.csa-swiper-main .swiper-slide');
  const thumbSlides = section.querySelectorAll('.csa-swiper-thumbs .swiper-slide');
  if (thumbSlides.length === 0 || mainSlides.length === 0) return;

  thumbSlides.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () {
      thumbSlides.forEach((t) => t.classList.remove('swiper-slide-thumb-active'));
      thumb.classList.add('swiper-slide-thumb-active');

      mainSlides.forEach(function (slide, sIndex) {
        if (sIndex === index) {
          slide.style.display = 'flex';
        } else {
          slide.style.display = 'none';
        }
      });
    });
  });
}

/* Tabs Switching Handler */
function initTabs(container) {
  const tabBtns = container.querySelectorAll('.csa-tab-btn');
  const tabPanes = container.querySelectorAll('.csa-tab-pane');

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const targetTab = btn.getAttribute('data-tab');

      tabBtns.forEach((b) => b.classList.remove('active'));
      tabPanes.forEach((p) => p.classList.remove('active'));

      btn.classList.add('active');
      const targetPane = container.querySelector('#csa-tab-pane-' + targetTab);
      if (targetPane) {
        targetPane.classList.add('active');
      }
    });
  });
}

/* Dynamic Shipping Date Calculation (e.g. Thu, Aug 6) */
function initDynamicShippingDate(container) {
  const autoDateElements = container.querySelectorAll('[data-auto-date="true"]');
  if (autoDateElements.length === 0) return;

  autoDateElements.forEach(function (el) {
    const offset = parseInt(el.getAttribute('data-days-offset') || '0', 10);
    const targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + offset);

    const options = { weekday: 'short', month: 'short', day: 'numeric' };
    const formattedDate = targetDate.toLocaleDateString('en-US', options);

    el.textContent = formattedDate;
  });
}

/* Variant Change Handler: Auto-slide gallery to variant featured image */
function initVariantChangeListener(container, mainSwiper) {
  container.addEventListener('change', function (event) {
    if (event.target.matches('variant-selects select, variant-radios input')) {
      setTimeout(function () {
        const selectedVariantInput = container.querySelector('product-form input[name="id"]');
        if (!selectedVariantInput) return;

        const variantId = selectedVariantInput.value;
        const matchingSlide = container.querySelector(`.swiper-slide[data-variant-id="${variantId}"]`);

        if (matchingSlide && mainSwiper) {
          const slideIndex = Array.from(matchingSlide.parentNode.children).indexOf(matchingSlide);
          if (slideIndex !== -1) {
            mainSwiper.slideTo(slideIndex);
          }
        }
      }, 150);
    }
  });
}

/* Accordions Handler with Smooth Slide Animation */
function csaSlideUp(element, duration) {
  if (!element) return;
  duration = duration || 250;
  element.style.height = element.offsetHeight + 'px';
  element.style.transitionProperty = 'height, margin, padding';
  element.style.transitionDuration = duration + 'ms';
  element.style.transitionTimingFunction = 'cubic-bezier(0.4, 0, 0.2, 1)';
  element.offsetHeight; // force reflow
  element.style.overflow = 'hidden';
  element.style.height = '0px';
  window.setTimeout(function () {
    element.style.display = 'none';
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
    element.style.removeProperty('transition-duration');
    element.style.removeProperty('transition-property');
    element.style.removeProperty('transition-timing-function');
  }, duration);
}

function csaSlideDown(element, duration) {
  if (!element) return;
  duration = duration || 250;
  element.style.removeProperty('display');
  var display = window.getComputedStyle(element).display;
  if (display === 'none') display = 'block';
  element.style.display = display;
  var height = element.offsetHeight;
  element.style.overflow = 'hidden';
  element.style.height = '0px';
  element.offsetHeight; // force reflow
  element.style.transitionProperty = 'height, margin, padding';
  element.style.transitionDuration = duration + 'ms';
  element.style.transitionTimingFunction = 'cubic-bezier(0.4, 0, 0.2, 1)';
  element.style.height = height + 'px';
  window.setTimeout(function () {
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
    element.style.removeProperty('transition-duration');
    element.style.removeProperty('transition-property');
    element.style.removeProperty('transition-timing-function');
  }, duration);
}

function initAccordions(container) {
  const accordionHeaders = container.querySelectorAll('.csa-accordion-header');
  accordionHeaders.forEach(function (header) {
    if (header.hasAttribute('data-accordion-initialized')) return;
    header.setAttribute('data-accordion-initialized', 'true');

    header.addEventListener('click', function () {
      const item = header.closest('.csa-accordion-item, .csa-block-accordion');
      if (!item) return;

      const content = item.querySelector('.csa-accordion-content');
      const isExpanded = header.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        header.setAttribute('aria-expanded', 'false');
        item.classList.remove('is-open');
        if (content) {
          csaSlideUp(content, 250);
        }
      } else {
        header.setAttribute('aria-expanded', 'true');
        item.classList.add('is-open');
        if (content) {
          csaSlideDown(content, 250);
        }
      }
    });
  });
}

